<template>
  <section id="contact">
    <div class="">
      <div class="z-10 text-center px-16 pb-16 pt-16 pb-3 bg-image-1">
        <h2 class="text-xl font-bold text-white sm:text-2xl md:text-3xl pb-4" data-aos="fade-up" data-aos-id-contact>
          お問い合わせ
        </h2>
        <p
          class="text-base font-bold text-white"
          data-aos="fade-up"
          data-aos-anchor="[data-aos-id-contact]"
          data-aos-delay="100"
        >
          上記サービスに関しての質問や、その他のご相談があれば、<br />
          お気軽にご連絡ください。
        </p>
        <a
          class="mx-auto flex mt-12 pl-16 p-4 bg-white hover:bg-gray-100 button"
          href="mailto:akitomo3420@gmail.com"
          data-aos="fade-up"
          data-aos-anchor="[data-aos-id-contact]"
          data-aos-delay="200"
        >
          <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
          <span class="block font-bold text-theme-900">お問い合わせはこちら</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style scoped>
.bg-image-1 {
  background-image: url("./../images/contact-background.jpg");
  background-size: cover;
  background-position: center;
}
.button {
  max-width: 300px;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
</style>
